import { z } from 'zod'
import type {
  PostPasswordResetBody,
  PutPasswordResetBody,
} from '@bruce/api/api/user/password/reset/body'
import type { Language } from '@bruce/components'
import { RESET_STRINGS } from './strings'
import { STRINGS } from '$lib/constants/strings'

export const resetLinkSchema = (lang: Language) => {
  return z.object({
    email: z.string().email({ message: STRINGS[lang].EMAIL_INVALID }),
    'cf-turnstile-response': z.string(),
  }) satisfies z.ZodType<PostPasswordResetBody>
}

export const resetSchema = (lang: Language) => {
  return z
    .object({
      password: z.string().min(8, RESET_STRINGS[lang].PASSWORD_MIN_LENGTH),
      password_confirmation: z
        .string()
        .min(8, RESET_STRINGS[lang].PASSWORD_MIN_LENGTH),
      secret: z.string(),
    })
    .refine(
      ({ password, password_confirmation }) =>
        password === password_confirmation,
      {
        message: RESET_STRINGS[lang].PASSWORDS_MUST_MATCH,
        path: ['password_confirmation'],
      },
    )
    .transform(
      ({ password_confirmation, ...formData }) => formData,
    ) satisfies z.ZodType<PutPasswordResetBody>
}

export type FormInput = z.input<ReturnType<typeof resetLinkSchema>>
export type FormOutput = z.output<ReturnType<typeof resetLinkSchema>>
